export const customersUrl = '/crm/customers/';

export default { customersUrl };
